import { render } from "./UsersIcon.vue?vue&type=template&id=8c84f754"
const script = {}

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__